import { useSyncExternalStore } from 'react';

export function usePortSnapshot<T>(port: {
  getSnapshot(): T;
  subscribe(listener: () => void): () => void;
}): T {
  return useSyncExternalStore(port.subscribe.bind(port), port.getSnapshot.bind(port), port.getSnapshot.bind(port));
}
